<template>
  <i class="pointer pi" @click.prevent="toggle()" :class="{'pi-chevron-up' : show, 'pi-chevron-down' : !show}" :key="pKey"></i>
</template>

<script>
  export default {
    name: "Toggle",
    props: {
      show : Boolean,
      pKey : String
    },

    methods:{
      toggle(){
        this.$emit('change', !this.show);
      }
    }
  }
</script>